import React from "react";
import Banner from "../components/Banner";
import SareeCategory from "../components/SareeCategory";
import OtherCategory from "../components/OtherCategory.jsx";
import "../assets/styles/Home.css";

const Home = () => {
  return (
    <div className="home">
      <Banner />
      <div className="category-section">
        <SareeCategory />
        <OtherCategory />
      </div>
    </div>
  );
};

export default Home;
